import type { TooltipProps } from '@radix-ui/react-tooltip';
import { Content, Portal, Provider, Root, Trigger } from '@radix-ui/react-tooltip';
import clsx from 'clsx';
import type { ComponentProps, FunctionComponent } from 'react';

const TooltipContent: FunctionComponent<ComponentProps<typeof Content>> = ({ className, ...props }) => (
    <Content
        className={clsx(
            'bg-gray-900 rounded-sm shadow-md text-white-200 text-xxs font-sans font-normal leading-[1rem] max-w-[300px] px-s py-xs z-[99999]',
            className,
        )}
        {...props}
    />
);

export const Tooltip: FunctionComponent<TooltipProps> & {
    Content: typeof TooltipContent;
    Portal: typeof Portal;
    Provider: typeof Provider;
    Root: typeof Root;
    Trigger: typeof Trigger;
} = ({ children, delayDuration = 200, ...props }) => {
    return (
        <Provider delayDuration={delayDuration}>
            <Root {...props}>{children}</Root>
        </Provider>
    );
};

Tooltip.Provider = Provider;
Tooltip.Root = Root;
Tooltip.Trigger = Trigger;
Tooltip.Content = TooltipContent;
Tooltip.Portal = Portal;
